/* Google Tag Manager Enums */

export enum GtmEvents {
  GTM_EVENT_TO_GA = 'GTM event to GA',
  BEGIN_CHECKOUT = 'begin_checkout',
  PURCHASE = 'purchase',
}

export enum GtmCategories {
  LOGIN = 'login',
  SIGNUP = 'signup',
  ECOMMERCE = 'ecommerce',
  FORM_FIELD_FILL = 'form field fill',
}

export enum SignupFormActions {
  FULL_NAME = 'full name',
}

export enum GtmActions {
  // LOGIN
  LOGIN_SUCCESS = 'login success',
  LOGIN_FAILED = 'login failed',
  LOGIN_ATTEMPT = 'login attempt',
  LOGIN_CLICK = 'login click',
  ENTER_VERIFICATION_CODE = 'enter verification code',
  // SIGNUP
  SIGNUP_SUCCESS = 'signup success',
  SIGNUP_ATTEMPT = 'signup attempt',
  SIGNUP_FAILED = 'signup failed',
  SMS_VERIFICATION_CLICK = 'sms verification click',
  SIGNUP_VALIDATION_SUCCESS = 'signup validation success',
  SIGNUP_VALIDATION_FAILED = 'signup validation failed',
  ENTER_VERIFICATION_CODE_CLICK = 'enter verification code click',
  SIGNUP_AGAIN_CLICK = 'signup again click',
  CONTACT_SUPPORT_CLICK = 'contact support click',
  RESEND_SMS_CLICK = 'resend sms click',
  RESEND_EMAIL_VERIFICATION_CLICK = 'resend Email verification click',
  RESEND_EMAIL_VERIFICATION_SUCCESS = 'resend Email verification success',
  RESEND_EMAIL_VERIFICATION_FAILED = 'resend Email verification failed',
  INSTALL_EXTENSION_CLICK = 'install extension click',
  VIEW_ACCOUNT = 'View account',
  // CHECKOUT
  PURCHASE = 'purchase',
  CHECKOUT_PAGE = 'checkout page',
  SYSTEM_ERROR = 'system error',
}

export enum GtmLabels {
  BODY = 'body',
  // LOGIN
  LOGIN_SUCCESS = 'login success',
  LOGIN_FAILED = 'login failed',
  LOGIN_ATTEMPT = 'login attempt',
  LOGIN_SCREEN = 'login screen',
  SIGNUP_ATTEMPT = 'signup attempt',
  ENTER_VERIFICATION_CODE = 'enter verification code',
  // SIGNUP
  SMS_VERIFICATION_CLICK = 'sms verification click',
  SIGNUP_VALIDATION_SUCCESS = 'signup validation success',
  ENTER_VERIFICATION_CODE_CLICK = 'enter verification code click',
  RESEND_SMS_CLICK = 'resend sms click',
  // CHECKOUT
  PURCHASE = 'purchase',
  EMAIL = 'email',
  GOOGLE = 'google',
  OFFICE = 'office',
  SYSTEM_ERROR = 'system error',
  // COUPONS
  COUPON_APPLY = 'checkout-coupon-apply',
  COUPON_SUCCESS = 'checkout-coupon-success',
  COUPON_FAIL = 'checkout-coupon-fail',
}
